import React from 'react';
import { Col, Form, Input, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const InfoSection = ({ isView }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title disabled={isView} level={3}>
          {t('Info')}
        </Typography.Title>
      </Col>
      <Col span={6}>
        <Form.Item label={t('Titolo IT')} name='title_it'>
          <Input disabled={isView} placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item label={t('Titolo EN')} name='title_en'>
          <Input disabled={isView} placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item label={t('Titolo FR')} name='title_fr'>
          <Input disabled={isView} placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col offset={6} span={18}>
        <Form.Item label={t('Richiedente')} name='author'>
          <Input disabled={isView} placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(InfoSection);
